import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/organization')({
  head: () => ({
    meta: [{ title: 'Organization | Tekst' }],
  }),
});
